var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Skeleton',{staticClass:"settings-group",attrs:{"loading":!_vm.isReady,"delay":300,"minDuration":250},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return _vm._l((_vm.skeletonCount),function(item){return _c('ItemSkeleton',{key:item,staticClass:"group-skeleton-item"})})},proxy:true}])},[[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }